import {ApiRequest, ApiResponse} from "@gongt/ts-stl-library/request/protocol";
import {ERequestType} from "@gongt/ts-stl-library/request/request";
import {IUserDataNormalizedClient, IUserProfileBase} from "../define";

export type WELL_KNOWN_PLATFORM = "unknown"|"webpage"|"android"|"ios";

export const UserLoginUrl = `/do_login`;
export const UserLoginMethod = ERequestType.TYPE_POST;

export interface UserLoginBody extends ApiRequest {
	login: string;
	password: string;
	platform?: WELL_KNOWN_PLATFORM;
}

export interface UserLoginResponse<IProfile extends IUserProfileBase> extends ApiResponse {
	user: IUserDataNormalizedClient<IProfile>;
	token: string;
}
